import { AudioSoundEvent, Exercise, Phase, ScheduleEntryColourCode, SessionSequence } from '../../../entities';
import { ISessionSequenceStrategy } from '../isessionsequencestrategy';

export class HomePauseAtWorkoutStarting implements ISessionSequenceStrategy {
  public getSessionSequence(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAternativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter: number,
  ): SessionSequence[] {
    // Todo calculate this time based on diff between startTime and startTimeOfFirstExercise
    const tenMinutes = 600;
    return [{
      durationInMilliseconds: tenMinutes,
      sequence: [{
        durationInMilliseconds: tenMinutes,
        videoFile: exercise.uniqueReferenceNumber,
        exerciseVersion: exercise._rev,
        displayName: exercise.name,
        displayBurnOrBuildIcon: true,
        progressColourCode: ScheduleEntryColourCode.Rest,
        progressText: 'Starting in {seconds}',
        showProcessedMetrics: false,
        showCalculatedMetrics: false,
        audioSoundEvent: AudioSoundEvent.startOfRestPeriod,
        tips: Exercise.getFormattedTips(exercise),
        audioTipStartDelay: 1000,
        audioTipFileName: exercise.voiceTipFileName,
        phase: Phase.Rest,
        videoHasAudio: true,
        zone,
        showLargeViewInGroupWorkout: true,
      }],
    }];
  }
}
